import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            Discover when people are near your stores and how long they stay. Spot busy times and quieter
            moments to help you plan marketing, staffing and day-to-day operations.
        </>
    );
};

export default Subtitle;
